import { Component, OnInit } from '@angular/core';
import { LinhaExtrato } from '../../../models/linhaExtrato.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ExtratoService } from '../../../services/importacao-extrato.service';
import { SpinnerService } from '../../../services/spinner.service';
import { TipoTransacao } from '../../../models/enums/tipoTransacao.enum';
import { TipoCorrecaoTransacao } from '../../../models/enums/tipoCorrecaoTransacao.enum';
import { TipoContaBancaria } from '../../../models/enums/tipoContaBancaria.enum';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { FormataDataHelper } from '../../../helpers/formata-data.helper';

@Component({
  selector: 'app-detalhes-extrato-bancario',
  templateUrl: './detalhes-extrato-bancario.component.html',
  styleUrls: ['./detalhes-extrato-bancario.component.scss'],
})
export class DetalhesExtratoComponent implements OnInit {
  linhaExtrato: LinhaExtrato | undefined;
  loading: boolean = true;

  constructor(
    private extratoService: ExtratoService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private formataDataHelper: FormataDataHelper
  ) { }

  ngOnInit() {
    this.spinnerService.show();

    const codigoTransacao = this.route.snapshot.paramMap.get('codigoTransacao');
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as { linhaExtrato: LinhaExtrato };

    if (state && state.linhaExtrato) {
      this.linhaExtrato = state.linhaExtrato;
      this.spinnerService.hide();
      this.loading = false;
    } else if (codigoTransacao) {
      this.extratoService.getCurrentExtrato().subscribe((extrato) => {
        if (extrato && codigoTransacao) {
          this.linhaExtrato = extrato.linhasExtratos.find(
            (linha) => linha.codigoTransacao === codigoTransacao
          );
          if (!this.linhaExtrato) {
            this.toastService.setMensagemToast(
              'Linha do extrato não encontrada.',
              SeveridadeToast.Error
            );
            this.router.navigate(['/importacao-extrato-bancario']);
          }
        } else {
          this.router.navigate(['/importacao-extrato-bancario']);
        }
        this.loading = false;
        this.spinnerService.hide();
      });
    } else {
      this.router.navigate(['/importacao-extrato-bancario']);
      this.loading = false;
      this.spinnerService.hide();
    }
  }

  getTipoTransacaoLabel(tipoTransacao: number): string {
    return TipoTransacao[tipoTransacao] || 'Desconhecido';
  }

  getTipoContaBancariaLabel(tipoContaBancaria: TipoContaBancaria): string {
    return TipoContaBancaria[tipoContaBancaria] || 'Desconhecido';
  }

  getTipoCorrecaoTransacaoLabel(
    tipoCorrecaoTransacao: TipoCorrecaoTransacao
  ): string {
    return TipoCorrecaoTransacao[tipoCorrecaoTransacao] || 'Desconhecido';
  }

  formatarDataOperacao(dataOperacao: string): string {
    const [dia, mes, ano] = dataOperacao.split('-').map(part => parseInt(part, 10));
    const data = new Date(ano, mes - 1, dia);
    if (isNaN(data.getTime())) {
      return 'Data inválida';
    }
    return this.formataDataHelper.formatarData(data);
  }

  onBack() {
    this.router.navigate(['/importacao-extrato-bancario']);
  }
}
